/**
 * Project-wide slug utility — single source of truth for turning team /
 * match names into slugs used in URLs and filenames.
 *
 * - Lowercase
 * - Transliterates diacritics (`Türkiye` → `turkiye`)
 * - Strips non-ASCII-alphanumeric chars (`Côte d'Ivoire` → `cote-divoire`)
 */

import slugifyLib from 'slugify';

/**
 * Convert a free-text name to a URL/filename-safe slug.
 *
 * @param {string | null | undefined} name
 * @returns {string} The slugified name, or an empty string if `name` is falsy.
 */
const slugify = (name) =>
  name ? slugifyLib(name, { lower: true, strict: true }) : '';

export default slugify;
